import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { StarFillIcon, StarOutlineIcon } from 'static/icons';

interface Props {
  value: number;
  feedbackCount?: number;
  max?: number;
  onClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  children: React.ReactNode;
}

export const Rating: React.FC<Props> = ({
  value,
  feedbackCount,
  max = 5,
  onClick,
  children,
}) => {
  return (
    <Box
      display="flex"
      onClick={onClick}
      cursor={onClick ? 'pointer' : undefined}
      justifyContent="center"
    >
      <Box display="inline-flex" position="relative" alignItems="center">
        {Array.from(Array(value).keys()).map((_, i) => (
          <StarFillIcon key={String(i)} width={46} height={46} />
        ))}
        {Array.from(Array(max - value).keys()).map((_, i) => (
          <StarOutlineIcon key={String(max - i)} width={46} height={46} />
        ))}
        {children}
      </Box>
      {feedbackCount && (
        <Text color="grayText" textStyle="body2">
          {`(${feedbackCount})`}
        </Text>
      )}
    </Box>
  );
};
